import { Component, Input, OnDestroy } from '@angular/core'
import { UiService } from 'src/app/services/ui.service'
import { Observable, Subscription } from 'rxjs'
import { ReleaseDetails } from 'src/app/services/release-details.service'

@Component({
  selector: 'app-application-upgrade-notice',
  templateUrl: './application-upgrade-notice.component.html',
  standalone: false,
})
export class ApplicationUpgradeNoticeComponent implements OnDestroy {
  @Input() upgradeNeeded = false
  @Input() canModify = false
  @Input() set releaseDetails$(value: Observable<ReleaseDetails[]>) {
    this._releaseDetails$ = value
    this.subscribeToDetails()
  }
  @Input() upgradeDetails: () => ReleaseDetails[]
  @Input() hasUpgradeDetails: () => boolean

  showAllDetails = false
  cachedDetails: ReleaseDetails[] = []
  detailsLoaded = false

  private _releaseDetails$: Observable<ReleaseDetails[]>
  private detailsSub: Subscription

  constructor(public uiService: UiService) {}

  ngOnDestroy(): void {
    this.detailsSub?.unsubscribe()
  }

  // Subscribe to releaseDetails$ and cache the result once data arrives.
  // This avoids the race condition where ngOnChanges cached before async data loaded.
  private subscribeToDetails(): void {
    this.detailsSub?.unsubscribe()
    if (this._releaseDetails$) {
      this.detailsSub = this._releaseDetails$.subscribe(() => {
        this.cachedDetails = this.upgradeDetails?.() || []
        this.detailsLoaded = true
      })
    }
  }

  get displayedDetails(): ReleaseDetails[] {
    return this.showAllDetails ? this.cachedDetails : this.cachedDetails.slice(0, 4)
  }

  get hasMoreDetails(): boolean {
    return this.cachedDetails.length > 4
  }

  get remainingCount(): number {
    return this.cachedDetails.length - 4
  }

  toggleShowAll() {
    this.showAllDetails = !this.showAllDetails
  }
}
